// extracted by mini-css-extract-plugin
module.exports = {"signatureWrapper":"signatureWrapper--XKhmF","signatureCanvas":"signatureCanvas--2G8K-","signatureHelper":"signatureHelper--mqjLd"};